import React, {useContext, useRef, useState} from 'react';
import './InitialOrderPopup.less';
import {DrawerPopup} from "../../dialog-layout/drawer-popup/DrawerPopup";
import {
    getBrowserFullLocale,
    getPhoneCodeForFullLocale,
    getSafeTranslation
} from "../../../helpers/localization.helper";
import {TranslationsContext} from "../../../contexts/translations-context";
import {Button} from "../../elements/button/Button";
import {Input} from "../../elements/input/Input";
import {Select} from "elements/select/Select";
import ReCAPTCHA from "react-google-recaptcha";
import Config from "../../../config";
import {Error} from "elements/error/Error";

function getCodeFromPhone(phoneCodes, phone) {
    return phoneCodes.find(phoneCode => new RegExp('^' + phoneCode.value.replace('+', '\\+')).test(phone));
}

export const INITIAL_ORDER_POPUP = 'INITIAL_ORDER_POPUP';


export const InitialOrderPopup = (
    {
        currentRestaurant,
        error,
        isRequestInProgress,
        phoneCodes,
        onCancel,
        onLogin,
        onSignup
    }
) => {
    const defaultPhoneCode = getPhoneCodeForFullLocale(
        phoneCodes,
        getBrowserFullLocale()
    );
    const translations = useContext(TranslationsContext);
    const [code, setCode] = useState(defaultPhoneCode.value)
    const [phone, setPhone] = useState(defaultPhoneCode.value);
    const [reCaptchaErrorState, setReCaptchaErrorState] = useState(null);

    const selectChanged = (newCode) => {
        setPhone(newCode + phone.replace(code, ''))
        setCode(newCode);
        setTimeout(() => {
            document.getElementById('phone-number-input').focus();
        }, 200);
    }

    const [reCaptchaLoaded, setRecaptchaLoaded] = useState(false);

    const reCaptchaRef = useRef(null);

    const reCaptchaLoadedAsync = () => {
        setRecaptchaLoaded(true);
    }
    const reCaptchaAsyncSubmit = () => {
        reCaptchaRef.current.executeAsync().then(value => {
            if (!value) {
                reCaptchaError();
                return;
            }
            onLogin(phone);
            setReCaptchaErrorState(null);
        });
    }
    const reCaptchaError = () => {
        setReCaptchaErrorState(getSafeTranslation('ReCaptcha.error', translations))
    }

    return (
        <DrawerPopup
            title={
                getSafeTranslation('GuestOrderPopup.title', translations)
            }
            onOverlayClick={onCancel}
            leftControl={<Button
                isText
                onClick={onCancel}
            >
                {getSafeTranslation('GuestOrderPopup.cancelButtonCaption', translations)}
            </Button>}
        >
            <div className="initial-order-popup">
                <div className="login-card">
                    <div className="login-card__title">
                        {getSafeTranslation('InitialOrderPopup.login', translations)}
                    </div>
                    {
                        error && <Error text={error}/>
                    }
                    <div className="login-card__form">
                        <div className="login-card__form-input">
                            <div className="login-card__form-input__label">
                                {getSafeTranslation('GuestOrderPopup.guestCardPhoneLabel', translations)}
                            </div>
                            <div className="phone">
                                <div className="phone__input-container">
                                    <div className="phone__code">
                                        <Select
                                            items={phoneCodes.map(phoneCode => ({
                                                id: phoneCode.value,
                                                name: phoneCode.description
                                            }))}
                                            selectedItemId={code}
                                            onChange={selectChanged}
                                            key={code}
                                        />
                                    </div>
                                    <div className="phone__number">
                                        <Input
                                            value={phone}
                                            inputMode="tel"
                                            regex={/^[\+\d\s]*$/}
                                            onChange={newPhone => {
                                                setPhone(newPhone);
                                                setCode(getCodeFromPhone(phoneCodes, newPhone).value);
                                            }}
                                            id={'phone-number-input'}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="login-card__form-input__helper">
                                {getSafeTranslation('GuestOrderPopup.guestCardPhoneLabelDescription', translations)}
                            </div>
                        </div>
                        <div className="login-card__action">
                            <Button isDisabled={isRequestInProgress || !reCaptchaLoaded}
                                    onClick={() => reCaptchaAsyncSubmit()}>{getSafeTranslation('InitialOrderPopup.continueLogin', translations)}</Button>
                        </div>
                    </div>
                    <ReCAPTCHA
                        sitekey={Config.reCaptchaSiteKey}
                        ref={reCaptchaRef}
                        asyncScriptOnLoad={reCaptchaLoadedAsync}
                        theme={'dark'}
                        size={'invisible'}
                        style={{marginTop: '24px'}}
                        badge={'inline'}
                        onErrored={reCaptchaError}
                    />
                    {
                        reCaptchaErrorState &&
                        (
                            <div className="reCaptcha-error">{reCaptchaErrorState}</div>
                        )
                    }
                </div>
                <div className="separator">{getSafeTranslation('GuestOrderPopup.or', translations)}</div>
                <div className="signup-card">
                    <div className="signup-card__title">
                        {getSafeTranslation('InitialOrderPopup.signupCardTitle', translations)}
                    </div>
                    <div className="signup-card__description">
                        {getSafeTranslation('InitialOrderPopup.signupCardDescription', translations)}
                    </div>
                    <div className="signup-card__action">
                        <Button onClick={onSignup}>{getSafeTranslation('InitialOrderPopup.signUp', translations)}</Button>
                    </div>
                </div>

            </div>
        </DrawerPopup>
    );
}
